import { injectGlobal } from '@emotion/css';
import type { CSSObject } from '@emotion/serialize';
import { type ImageContinuousType, CONTINUOUS_DEFAULTS } from '../types/animation';

const CONTINUOUS_ANIMATION_KEYFRAMES = `
@keyframes b4-kenBurns {
  0% { transform: scale(1) translate(0, 0); }
  50% { transform: scale(var(--b4-kb-scale, 1.1)) translate(var(--b4-kb-tx, -1%), var(--b4-kb-ty, -1%)); }
  100% { transform: scale(1) translate(0, 0); }
}
@keyframes b4-slowZoom {
  0% { transform: scale(1); }
  50% { transform: scale(var(--b4-sz-scale, 1.08)); }
  100% { transform: scale(1); }
}
@keyframes b4-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: var(--b4-pulse-opacity, 0.85); }
}
`;

let continuousKeyframesInjected = false;

export const injectContinuousKeyframes = () => {
  if (continuousKeyframesInjected) return;
  continuousKeyframesInjected = true;
  injectGlobal(CONTINUOUS_ANIMATION_KEYFRAMES);
};

export const getContinuousAnimationStyle = (
  continuousAnimation: ImageContinuousType | undefined,
  continuousSpeed?: number,
  continuousIntensity?: number,
): CSSObject => {
  if (!continuousAnimation || continuousAnimation === 'none') {
    return {};
  }

  injectContinuousKeyframes();

  const defaults = CONTINUOUS_DEFAULTS[continuousAnimation];
  if (!defaults) return {};

  const speed = continuousSpeed ?? defaults.speed;
  const intensity = continuousIntensity ?? defaults.intensity;

  const style: CSSObject = {
    animation: `b4-${continuousAnimation} ${speed}s ease-in-out infinite`,
  };

  if (continuousAnimation === 'kenBurns') {
    const scale = 1 + intensity / 100;
    const translate = -(intensity / 10);
    style['--b4-kb-scale'] = `${scale}`;
    style['--b4-kb-tx'] = `${translate}%`;
    style['--b4-kb-ty'] = `${translate}%`;
  } else if (continuousAnimation === 'slowZoom') {
    const scale = 1 + intensity / 100;
    style['--b4-sz-scale'] = `${scale}`;
  } else if (continuousAnimation === 'pulse') {
    const opacity = 1 - intensity / 100;
    style['--b4-pulse-opacity'] = `${opacity}`;
  }

  return style;
};
